// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";

import { Image, Tabs, TabPane, Table, TableColumn, Icon, Carousel, CarouselItem, Breadcrumb, BreadcrumbItem, Pagination } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Image);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Icon);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Pagination);

import store from "./store";
/* 路由 */
import router from "./router";

/* axios */
import axios from "./api";
import api from "./api/api";
Vue.prototype.http = axios;
Vue.prototype.api = api;

Vue.use(ViewUI);

/* swiper */
import "swiper/dist/css/swiper.min.css";

/* 重置样式 */
import "./assets/css/reset.min.css";

/* jquery */
import "jquery";

/* bootstarp */
import "./assets/css/bootstrap.min.css";
import "./assets/js/bootstrap.min";

/* animate.css */
import "animate.css";

/* 头部组件 */
import Header from "./components/Header";
Vue.component(Header.name, Header);

/* 尾部组件 */
import Footer from "./components/Footer";
Vue.component(Footer.name, Footer);

/* 回到顶部 */
import GoTop from "./components/GoTop";
Vue.component(GoTop.name, GoTop);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});

// console.log(new Date().Format("yyyy-MM-dd hh:mm:ss"));//时间戳转时间
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1,//月
    "d+": this.getDate(),//日
    "h+": this.getHours(),//小时
    "m+": this.getMinutes(),//分
    "s+": this.getSeconds(),//秒
    "q+": Math.floor((this.getMonth() + 3) / 3),//季度
    "S": this.getMilliseconds()//毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};


// WEBPACK FOOTER //
// ./src/main.js